import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGeolocated } from 'react-geolocated';
import { useTranslation, getI18n } from 'react-i18next';
import { useMask } from '@react-input/mask';
import { Button, Stack, Typography, Input } from '@mui/joy';
import api from '../../api/apiClient';
import useAppStore from '../../store/appStore';
import { handleError } from '../../utils/error-handling';
import checkPGN from '../../utils/checkPGN';

function CaseInputPage() {
  const [caseNumber, setCaseNumber] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setToken } = useAppStore();

  const inputRef = useMask({
    mask: 'XXX_DDHDDDDDDD',
    replacement: {
      X: /[0-9A-Za-z]/,
      D: /[0-9]/,
      H: /(C|c|-)/,
      _: /-/,
    },
  });

  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: false,
      },
      userDecisionTimeout: 5000,
      watchPosition: true,
    });

  const handleSubmit = async e => {
    e.preventDefault();
    if (!checkPGN(caseNumber)) {
      handleError('error', t('caseInputPage.invalidCaseNumber'));
      return;
    }
    if (!isGeolocationAvailable || !isGeolocationEnabled) {
      handleError('error', t('caseInputPage.enableGeolocation'));
      return;
    }
    try {
      const res = await api.post('/auth/', { caseNumber, geoLocation: coords });
      setToken(res.data.token);
      navigate('/otp', { state: { maskedNumber: res.data.maskedNumber } });
    } catch (error) {
      console.log(error.response?.data?.tr);
      handleError(
        'error',
        t(`caseInputPage.${error.response?.data?.tr}`) ||
          error.response?.data?.error[getI18n().language] ||
          t('genericError')
      );
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-[50vh]">
      <Stack spacing={4}>
        <Typography level="h2">{t('caseInputPage.enterCaseNumber')}</Typography>
        <form onSubmit={handleSubmit}>
          <Stack direction="row" spacing={2}>
            <Input
              value={caseNumber}
              autoFocus
              onChange={e => setCaseNumber(e.target.value)}
              className="border p-2"
              slotProps={{
                input: {
                  ref: inputRef,
                  style: { direction: 'ltr' },
                },
              }}
            />
            <Button type="submit" variant="soft" color="success">
              {t('caseInputPage.submit')}
            </Button>
          </Stack>
        </form>
      </Stack>
    </div>
  );
}

export default CaseInputPage;
